import React, { Component, Suspense } from 'react';
import { Routes, Route, Navigate, NavLink, Link, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg';
import 'reactjs-popup/dist/index.css';
import { withTranslation } from 'react-i18next';
import { CURRENCY_CONFIGS, LANG_CURRENCY_MAP } from '../utils/numberFormat';

import GlobalLoading from './../components/global/Loading';
import FormSelect from './../components/form/Select';
import withRouter from './../helper/withrouter';
import { ReactComponent as Logo } from './../assets/img/logo.svg';
import { ReactComponent as IconDashboard } from './../assets/img/icon/icon-nav-dashboard.svg';
import { ReactComponent as IconCampaign } from './../assets/img/icon/icon-nav-campaign.svg';
import { ReactComponent as IconCompany } from './../assets/img/icon/icon-nav-company.svg';
import { ReactComponent as IconUser } from './../assets/img/icon/icon-nav-user.svg';
import { ReactComponent as IconCustomer } from './../assets/img/icon/icon-nav-customer.svg';
import { ReactComponent as IconBalance } from './../assets/img/icon/icon-nav-balance.svg';
// import { ReactComponent as IconNetwork } from './../assets/img/icon/icon-nav-network.svg';
// import { ReactComponent as IconBell } from './../assets/img/icon/icon-bell.svg';
import { ReactComponent as IconMenu } from './../assets/img/icon/icon-menu.svg';
import { ReactComponent as IconAccount } from './../assets/img/icon/icon-account.svg';
import { ReactComponent as IconLogout } from './../assets/img/icon/icon-logout.svg';
import TokenManager from '../services/tokenManager';
import { isMerchantOwner } from '../services/api/merchantAccountService';
import { resetUnauthorizedFlag } from '../axiosConfig';
import BannerStack from './../components/global/BannerStack';
import ServiceFeeBanner from './../components/global/ServiceFeeBanner';
import MarketingBalanceBanner from './../components/global/MarketingBalanceBanner';
import PopAdvisorConsent from './../components/global/PopAdvisorConsent';
import { loadSubscription, clearSubscription, isRenewalFlow, startRenewalFlow, SUBSCRIPTION_UPDATED_EVENT, SERVICE_FEE_STATUS } from '../services/subscription';
import { loadBalance, refreshBalance, shouldWarnBalance, startTopupFlow, clearBalanceState, formatBalanceAmount, BALANCE_UPDATED_EVENT } from '../services/balanceState';
import { loadAdvisor, refreshAdvisor, clearAdvisorState, ADVISOR_UPDATED_EVENT } from '../services/advisorState';

const Sign = React.lazy(() => import('./Sign/Sign')),
      Register = React.lazy(() => import('./Register/Register')),
// const Login = React.lazy(() => {
//         return new Promise(resolve => {
//           setTimeout(() => resolve(import('./Login/Login')), 300000);
//         });
//       }),
      Dashboard = React.lazy(() => import('./Admin/Admin')),
      Subscription = React.lazy(() => import('./Purchase/Subscription/Subscription')),
      UpdatePaymentMethod = React.lazy(() => import('./Purchase/UpdatePaymentMethod/UpdatePaymentMethod')),
      Checkout = React.lazy(() => import('./Purchase/Checkout/Checkout')),
      PaymentComplete = React.lazy(() => import('./Purchase/PaymentComplete/PaymentComplete')),
      VoucherPack = React.lazy(() => import('./Purchase/VoucherPack/VoucherPack')),
      TicketBundle = React.lazy(() => import('./Purchase/TicketBundle/TicketBundle')),
      RenewPlan = React.lazy(() => import('./Purchase/Renew/RenewPlan')),
      RenewPayment = React.lazy(() => import('./Purchase/Renew/RenewPayment')),
      RenewResult = React.lazy(() => import('./Purchase/Renew/RenewResult')),
      NotFound = React.lazy(() => import('./Purchase/NotFound/NotFound')),
      PurchaseLayout = React.lazy(() => import('./Purchase/PurchaseLayout')),
      AccountVerification = React.lazy(() => import('./Admin/Account/AccountVerification')),
      Terms = React.lazy(() => import('./Terms/Terms')),
      Privacy = React.lazy(() => import('./Privacy/Privacy'));

class App extends Component{
  constructor(){
    super();
    
    this.state = {
      signIn: '',
      mode: '',
      side: true,
      setting: {
        phoneCode: '+43',
        format: {
          time: 'hh:mm a',
          date: 'M/D/YYYY',
          dateTime: 'DD MMM YYYY hh:mm A',
        },
        currency: CURRENCY_CONFIGS.EUR_EN
      },
      dropOpen: false,
      lang: {
        value: 'en',
        label: 'English',
        flag: CountryFlagSvg['GB']
      },
      subscription: loadSubscription(),
      marketingBalance: loadBalance(),
      advisorName: loadAdvisor(),
      advisorOpen: false,
    }

    this.nav = [{
      name: 'dashboard',
      slug: '/dashboard',
      icon: <IconDashboard />
    }, {
      name: 'cashback',
      slug: '/cashback',
      icon: <IconCampaign />
    }, {
      name: 'companyManagement',
      slug: '/company-management',
      icon: <IconCompany />
    }, {
      name: 'userManagement',
      slug: '/user-management',
      icon: <IconUser />
    }, {
      name: 'shopperManagement',
      slug: '/shopper-management',
      icon: <IconUser />
    }, {
      name: 'customer',
      slug: '/customer',
      icon: <IconCustomer />
    }, {
      name: 'marketingBalanceMenu',
      slug: '/marketing-balance',
      icon: <IconBalance />
    }
    // , {
    //   name: 'Product Subscription',
    //   slug: '/product/subscription',
    //   icon: <IconCustomer />
    // }
    // , {
    //   name: 'Network',
    //   slug: '/network',
    //   icon: <IconNetwork />
    // }
    ];

    this.langOption = [{
      value: 'en',
      label: 'English',
      flag: CountryFlagSvg['GB']
    }, {
      value: 'it',
      label: 'Italy',
      flag: CountryFlagSvg['IT']
    }];
    
    this.accountRef = React.createRef();
    
    this.switchLogin = this.switchLogin.bind(this);
    this.updateMode = this.updateMode.bind(this);
    this.toggleSide = this.toggleSide.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.clickOutside = this.clickOutside.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.switchCurrency = this.switchCurrency.bind(this);
    this.openAdvisor = this.openAdvisor.bind(this);
    this.closeAdvisor = this.closeAdvisor.bind(this);
  }

  componentDidMount(){
    const lang = localStorage.getItem('skai1Language'),
          authToken = localStorage.getItem('skai1AccessToken'),
          signInStatus = sessionStorage.getItem('signIn');

    if(lang && lang !== this.state.lang.value){
      const findLang = this.langOption.find(x => x.value === lang);

      if(typeof findLang !== 'undefined'){
        this.setState({ lang: findLang });
      }else{
        localStorage.setItem('skai1Language', this.state.lang.value);
      }
    }else{
      localStorage.setItem('skai1Language', this.state.lang.value);
    }
    
    if (authToken && signInStatus === 'true') {
      this.setState({ signIn: true });
    } else if(this.state.signIn === '' && typeof sessionStorage.getItem('signIn') === 'undefined'){
      this.setState({ signIn: false });
      sessionStorage.setItem('signIn', false);
    } else {
      this.setState({ signIn: sessionStorage.getItem('signIn') === 'true' ? true : false });
    }

    document.addEventListener('click', this.clickOutside);

    this.handleUnauthorized = () => {
      TokenManager.clearTokens();
      sessionStorage.removeItem('signIn');
      // Token expired = akhir sesi — status subscription & balance ikut dibersihin
      // biar gak bocor ke login berikutnya (audit 2026-07-23)
      clearSubscription();
      clearBalanceState();
      clearAdvisorState();
      this.setState({ signIn: false, subscription: null, marketingBalance: null, advisorName: null, advisorOpen: false });
    };
    window.addEventListener('auth:unauthorized', this.handleUnauthorized);

    this.handleSubscriptionUpdated = (event) => {
      this.setState({ subscription: event.detail || null });
    };
    window.addEventListener(SUBSCRIPTION_UPDATED_EVENT, this.handleSubscriptionUpdated);

    this.handleBalanceUpdated = (event) => {
      this.setState({ marketingBalance: event.detail ?? null });
    };
    window.addEventListener(BALANCE_UPDATED_EVENT, this.handleBalanceUpdated);

    this.handleAdvisorUpdated = (event) => {
      this.setState({ advisorName: event.detail ?? null });
    };
    window.addEventListener(ADVISOR_UPDATED_EVENT, this.handleAdvisorUpdated);

    if(authToken && signInStatus === 'true'){
      refreshBalance();
      refreshAdvisor();
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.router.location !== prevProps.router.location){
      if(window.innerWidth <= 767){
        this.setState({ side: true });
      }

      // Pindah halaman (mis. tombol back) nutup modal advisor — biar gak kebuka sendiri lagi
      // pas balik ke /admin, karena modalnya ikut unmount bareng sidebar di luar mode dash.
      if(this.state.advisorOpen){
        this.setState({ advisorOpen: false });
      }

      // Re-evaluasi Marketing Balance tiap navigasi dalam admin (subtask balance-state refresh)
      if(this.state.signIn === true && this.props.router.location.pathname.startsWith('/admin')){
        refreshBalance();
      }
    }

    if(this.state.lang !== prevState.lang){
      if(this.state.lang){
        this.props.i18n.changeLanguage(this.state.lang.value);
        localStorage.setItem('skai1Language', this.state.lang.value);
        this.switchCurrency(LANG_CURRENCY_MAP[this.state.lang.value] ?? 'EUR_EN');
      }
    }
  }

  componentWillUnmount(){
    document.removeEventListener('click', this.clickOutside);
    window.removeEventListener('auth:unauthorized', this.handleUnauthorized);
    window.removeEventListener(SUBSCRIPTION_UPDATED_EVENT, this.handleSubscriptionUpdated);
    window.removeEventListener(BALANCE_UPDATED_EVENT, this.handleBalanceUpdated);
    window.removeEventListener(ADVISOR_UPDATED_EVENT, this.handleAdvisorUpdated);
  }
  
  switchLogin(event){
    if(event){
      event.stopPropagation();
    }

    const newSignInState = !this.state.signIn;

    if(newSignInState){
      resetUnauthorizedFlag();
      refreshBalance();
      refreshAdvisor();
      toast.success(<div className="toast-con"><div>{this.props.t('signInSuccess')}</div>{this.props.t('signInDesc')}</div>);
    }else{
      toast.success(<div className="toast-con"><div>{this.props.t('signOutSuccess')}</div>{this.props.t('signOutDesc')}</div>);
      localStorage.removeItem('userData');
      localStorage.removeItem('skai1AccessToken');
      localStorage.removeItem('userAccountData');
      TokenManager.clearTokens();
      clearSubscription();
      clearBalanceState();
      clearAdvisorState();
      this.setState({ subscription: null, marketingBalance: null, advisorName: null, advisorOpen: false });
    }

    this.setState({ signIn: newSignInState });
    sessionStorage.setItem('signIn', newSignInState);
  }

  updateMode(value){
    this.setState({ mode: value });
  }

  toggleSide(){
    this.setState({ side: !this.state.side });
  }

  toggleDropdown(){
    this.setState({ dropOpen: !this.state.dropOpen });
  }

  openAdvisor(){
    this.setState({ advisorOpen: true });
  }

  closeAdvisor(){
    this.setState({ advisorOpen: false });
  }

  getUserInitials(){
    try {
      const userAccountData = localStorage.getItem('userAccountData') || localStorage.getItem('userData');
      if (userAccountData) {
        const userData = JSON.parse(userAccountData);
        if (userData.name) {
          // Get first letter of each word in the name
          return userData.name
            .split(' ')
            .map(word => word.charAt(0).toUpperCase())
            .slice(0, 2) // Take only first 2 initials
            .join('');
        }
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
    return ''; // Fallback to default
  }

  clickOutside(event){
    if(this.accountRef.current){
      if(window.innerWidth <= 767){
        if(this.state.side === false && this.accountRef.current.contains(event.target) === true){
          this.toggleSide();
        }
      }

      if(!this.accountRef.current.contains(event.target)){
        this.setState({ dropOpen: false });
      }
    }
  }

  selectChange(value, event){
    this.setState({ [event.name]: value });
  }

  switchCurrency(code){
    const config = CURRENCY_CONFIGS[code];
    if (!config) return;
    this.setState(prevState => ({
      setting: { ...prevState.setting, currency: config }
    }));
  }

  render(){
    const { t } = this.props;

    return(
      <Suspense fallback={<GlobalLoading text="Loading" />}>
        <Routes>{/* Purchase routes with its own layout */}
          <Route path="/account/verify" element={
            this.state.signIn === '' || this.state.setting === '' ? <GlobalLoading text="Checking Authentication" page />
              : this.state.signIn ? <AccountVerification lang={this.state.lang} langOption={this.langOption} selectChange={this.selectChange} /> : <Navigate to="/sign/login" replace />
          } />
          <Route path="/product" element={<PurchaseLayout />}>
            <Route path="subscription" element={<Subscription />} />
            <Route path="update-payment-method" element={<UpdatePaymentMethod />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="payment-complete" element={<PaymentComplete />} />
            <Route path="voucher-pack" element={<VoucherPack />} />
            <Route path="ticket-bundle" element={<TicketBundle />} />
            <Route path="renew" element={<RenewPlan />} />
            <Route path="renew/payment" element={<RenewPayment />} />
            <Route path="renew/result" element={<RenewResult />} />
            <Route path="404" element={<NotFound />} />
          </Route>
          
          {/* Main application layout */}
          <Route path="*" element={
            <>
              <BannerStack>
                {/* Banner warning cuma di area admin — jangan ikut nongol di funnel /sign/* (renewalFlow) */}
                <ServiceFeeBanner
                  show={this.state.signIn === true && this.props.router.location.pathname.startsWith('/admin') && !!this.state.subscription && this.state.subscription.serviceFeeStatus !== SERVICE_FEE_STATUS.ACTIVE}
                  closable={this.state.subscription ? this.state.subscription.serviceFeeStatus === SERVICE_FEE_STATUS.GRACE : true}
                  onPay={() => startRenewalFlow(this.props.router.navigate)}
                  t={t}
                />
                <MarketingBalanceBanner
                  show={this.state.signIn === true && this.props.router.location.pathname.startsWith('/admin') && shouldWarnBalance(this.state.subscription, this.state.marketingBalance)}
                  amount={formatBalanceAmount(this.state.marketingBalance, this.props.i18n.language)}
                  onTopup={() => startTopupFlow(this.props.router.navigate)}
                  t={t}
                />
              </BannerStack>
              <header className={this.state.mode}>
                <button type="button" onClick={this.toggleSide}><IconMenu /></button>
                <Link to="/"><Logo /></Link>
                <ul className="floating lite nav">
                  {/* <li className="lay-auto">
                    <button type="button" className="btn btn-link"><IconBell /></button>
                  </li> */}
                  {this.state.mode === 'dash' ? (
                    <li className="lay-auto">
                      <button type="button" className="btn btn-unshine btn-account" onClick={this.toggleDropdown} ref={this.accountRef}>
                        {this.getUserInitials()}
                      </button>
                    </li>
                  ) : ''}
                </ul>
                <ul className={`dropdown ${this.state.dropOpen ? 'show' : ''}`}>
                  {isMerchantOwner() && <li>
                    <Link to="/admin/account-setting" onClick={() => this.setState({ dropOpen: false })}>
                      <IconAccount />{t('merchantAccount.title')}
                    </Link>
                  </li>}
                  <li>
                    <button type="button" onClick={this.switchLogin}>
                      <IconLogout />Log Out
                    </button>
                  </li>
                </ul>
                <div className="forming language">
                  <FormSelect
                    name="lang"
                    options={this.langOption}
                    value={this.state.lang}
                    onChange={this.selectChange}
                    formatOptionLabel={({ label, flag }) => (
                      <>
                        <div dangerouslySetInnerHTML={{__html: flag}} className="flag"></div> {label}
                      </>
                    )}
                    className="lite"
                  />
                </div>
              </header>

              <div className={`side-left ${this.state.mode} ${!this.state.side ? 'mini' : ''}`}>
                {this.state.mode === 'dash' ? (
                  <>
                    <ul className="floating lite">
                      {this.nav.map((value, index) => (
                        <li key={`nav-${index}`}>
                          <NavLink
                            to={`/admin${value.slug}`}
                            data-tooltip-id="nav"
                            data-tooltip-html={!this.state.side ? value.name : ''}
                          >
                            {value.icon}<span>{t(value.name)}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                    {/* Nama recommender/upline dari GET /partner/. Merchant tanpa upline dirender
                        '-' — BE pakai `omitempty` jadi key-nya absen, bukan string kosong.
                        Disembunyikan pas sidebar desktop nyusut, sama kayak label nav. */}
                    <div className="advisor">
                      <div className="advisor-head">
                        <h6>{t('advisor.title')}</h6>
                        {/* Buka modal consent (SKAI1-1457) — tampil juga pas advisor-nya '-',
                            consent-nya tetap ada di BE. */}
                        <button type="button" className="btn btn-link" onClick={this.openAdvisor}>{t('advisor.details')}</button>
                      </div>
                      <p>{this.state.advisorName ? this.state.advisorName : '-'}</p>
                      {/* Peran advisor gak ada di API — label statis, dan SELALU tampil,
                          termasuk pas advisor-nya masih '-'. Keputusan user 2026-09-10. */}
                      <p className="role">{t('advisor.role')}</p>
                    </div>
                    <PopAdvisorConsent open={this.state.advisorOpen} onClose={this.closeAdvisor} advisorName={this.state.advisorName} />
                  </>
                ) : ''}
              </div>
              <div className={`side-right ${this.state.mode} ${!this.state.side ? 'big' : ''}`}>
                <Suspense fallback={<GlobalLoading text="Loading" />}>
                  <Outlet />
                </Suspense>
              </div>

              <footer className={`${this.state.mode} ${!this.state.side ? 'big' : ''}`}>
                <ul className="floating inline">
                  <li className="lay-auto">&copy; 2026 SKAi1. {t('allRight')}.</li>
                  <li className="lay-auto"><Link to="/terms">{t('term')}</Link></li>
                  <li className="lay-auto"><Link to="/privacy">{t('privacy')}</Link></li>
                </ul>
              </footer>
            </>
          }>
            <Route index element={<Navigate to="/sign/login" />} />
            <Route path="sign/*" element={
              this.state.signIn === '' || this.state.setting === '' ? (<GlobalLoading text="Checking Authentication" page />)
              // Exception renewalFlow dibatasi ke halaman funnel pembayaran doang — signed-in
              // yang nyasar ke /sign/login dkk tetap dilempar balik ke /admin (audit 2026-07-23)
              : this.state.signIn && !(isRenewalFlow() && /^\/sign\/(pricing|checkout|congratulations|margin)/.test(this.props.router.location.pathname)) ? (<Navigate to="/admin" />) : (<Sign switchLogin={this.switchLogin} updateMode={this.updateMode} setting={this.state.setting} switchCurrency={this.switchCurrency} selectChange={this.selectChange} langOption={this.langOption} lang={this.state.lang} />)
            } />
            <Route path="admin/*" element={
              this.state.signIn === '' || this.state.setting === '' ? (<GlobalLoading text="Checking Authentication" page />)
              : this.state.signIn ? (<Dashboard switchLogin={this.switchLogin} updateMode={this.updateMode} setting={this.state.setting} switchCurrency={this.switchCurrency} />) : (<Navigate to="/sign" />)
            } />
            <Route path="register" element={
              this.state.signIn === '' || this.state.setting === '' ? (<GlobalLoading text="Checking Authentication" page />)
              : this.state.signIn ? (<Navigate to="/admin" />) : (<Register updateMode={this.updateMode} selectChange={this.selectChange} langOption={this.langOption} lang={this.state.lang}  />)
            } />
            <Route path="register/:voucherCode" element={
              this.state.signIn === '' || this.state.setting === '' ? (<GlobalLoading text="Checking Authentication" page />)
              : this.state.signIn ? (<Navigate to="/admin" />) : (<Register updateMode={this.updateMode} />)
            } />
            <Route path="terms" element={<Terms updateMode={this.updateMode} lang={this.state.lang} />} />
            <Route path="privacy" element={<Privacy updateMode={this.updateMode} lang={this.state.lang} />} />
          </Route>
        </Routes>
      </Suspense>
    );
  }
}

export default withRouter(withTranslation()(App));
